import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
    selector: 'app-fc-twofive-twosix',
    templateUrl: './fc-twofive-twosix.component.html',
    styleUrls: ['./fc-twofive-twosix.component.scss']
})
export class FcTwofiveTwosixComponent implements OnInit {
    src: string;
    isLoading = true;

    pdfSrc: string[] = [
        '/assets/pdf/MOU 2025-26.pdf'
    ];

    ngOnInit(): void {
        this.changeRoute('1');
    }

    changeRoute(year: string) {
        this.isLoading = true;

        $('.first,.second,.third,.four,.five,.six,.seven,.eight,.nine').removeClass('active');

        if (year == '1') { $('.first').addClass('active'); this.src = this.pdfSrc[0]; }
    }

    hideLoader() {
        this.isLoading = false;
    }
}
